import dateFns from 'date-fns/locale/uk';

export default {
  dateFns,

  format: {
    date: 'd/M/yyyy',
    time: 'p',
    dateTime: '$t(format:date) $t(format:time)',
    longDate: 'd MMMM',
    longDateTime: "d MMMM 'о' p",
    fullDate: 'd MMMM y',
    fullDateTime: "d MMMM y 'о' p",
  },

  translation: {
    common: {
      aboutPlanka: 'Про Planka',
      account: 'Обліковий запис',
      actions: 'Дії',
      addAttachment_title: 'Додати Вкладення',
      addComment: 'Додати коментар',
      addManager_title: 'Додати Менеджера',
      addMember_title: 'Додати Учасника',
      addUser_title: 'Додати Користувача',
      administrator: 'Адміністратор',
      all: 'Все',
      allChangesWillBeAutomaticallySavedAfterConnectionRestored:
        'Всі зміни будуть автоматично збережені<br />після відновлення підключення.',
      areYouSureYouWantToDeleteThisAttachment: 'Ви впевнені, що хочете видалити це вкладення?',
      areYouSureYouWantToDeleteThisBoard: 'Ви впевнені, що хочете видалити цю дошку?',
      areYouSureYouWantToDeleteThisCard: 'Ви впевнені, що хочете видалити цю картку?',
      areYouSureYouWantToDeleteThisComment: 'Ви впевнені, що хочете видалити цей коментар?',
      areYouSureYouWantToDeleteThisLabel: 'Ви впевнені, що хочете видалити цю мітку?',
      areYouSureYouWantToDeleteThisList: 'Ви впевнені, що хочете видалити цей список?',
      areYouSureYouWantToDeleteThisProject: 'Ви впевнені, що хочете видалити цей проект?',
      areYouSureYouWantToDeleteThisTask: 'Ви впевнені, що хочете видалити це завдання?',
      areYouSureYouWantToDeleteThisUser: 'Ви впевнені, що хочете видалити цього користувача?',
      areYouSureYouWantToLeaveBoard: 'Ви впевнені, що хочете залишити дошку?',
      areYouSureYouWantToLeaveProject: 'Ви впевнені, що хочете залишити проект?',
      areYouSureYouWantToRemoveThisManagerFromProject:
        'Ви впевнені, що хочете видалити цього менеджера з проекту?',
      areYouSureYouWantToRemoveThisMemberFromBoard:
        'Ви впевнені, що хочете видалити цього учасника з дошки?',
      attachment: 'Вкладення',
      attachments: 'Вкладення',
      authentication: 'Аутентифікація',
      background: 'Фон',
      board: 'Дошка',
      boardNotFound_title: 'Дошку не знайдено',
      canComment: 'Може коментувати',
      canEditContentOfBoard: 'Має право редагувати вміст дошки.',
      canOnlyViewBoard: 'Може лише переглядати дошку.',
      cardActions_title: 'Дії з карткою',
      cardNotFound_title: 'Картку не знайдено',
      cardOrActionAreDeleted: 'Картка чи дія видалена.',
      color: 'Колір',
      createBoard_title: 'Створити Дошку',
      createLabel_title: 'Створити Мітку',
      createNewOneOrSelectExistingOne: 'Створіть нову або виберіть<br />існуючу.',
      createProject_title: 'Створити Проект',
      createTextFile_title: 'Створити Текстовий Файл',
      currentPassword: 'Поточний пароль',
      dangerZone_title: 'Небезпечна Зона',
      date: 'Дата',
      dueDate_title: 'Крайній Термін',
      deleteAttachment_title: 'Видалити Вкладення',
      deleteBoard_title: 'Видалити Дошку',
      deleteCard_title: 'Видалити Картку',
      deleteComment_title: 'Видалити Коментар',
      deleteLabel_title: 'Видалити Мітку',
      deleteList_title: 'Видалити Список',
      deleteProject_title: 'Видалити Проект',
      deleteTask_title: 'Видалити Завдання',
      deleteUser_title: 'Видалити Користувача',
      description: 'Опис',
      detectAutomatically: 'Визначити автоматично',
      dropFileToUpload: 'Перетягніть файл для завантаження',
      editor: 'Редактор',
      editAttachment_title: 'Редагувати Вкладення',
      editAvatar_title: 'Редагувати Аватар',
      editBoard_title: 'Редагувати Дошку',
      editDueDate_title: 'Редагувати Крайній Термін',
      editEmail_title: 'Редагувати Електронну пошту',
      editInformation_title: 'Редагувати Інформацію',
      editLabel_title: 'Редагувати Мітку',
      editPassword_title: 'Редагувати Пароль',
      editPermissions_title: 'Редагувати Дозволи',
      editStopwatch_title: 'Редагувати Секундомір',
      editUsername_title: "Редагувати Ім'я користувача",
      email: 'Електронна пошта',
      emailAlreadyInUse: 'Електронна пошта вже використовується',
      enterCardTitle: 'Введіть назву картки... [Ctrl+Enter] для автоматичного відкриття.',
      enterDescription: 'Введіть опис...',
      enterFilename: "Введіть ім'я файлу",
      enterListTitle: 'Введіть назву списку...',
      enterProjectTitle: 'Введіть назву проекту',
      enterTaskDescription: 'Введіть опис завдання...',
      filterByLabels_title: 'Фільтрувати за Мітками',
      filterByMembers_title: 'Фільтрувати за Учасниками',
      fromComputer_title: "З комп'ютера",
      fromTrello: 'З Trello',
      general: 'Загальне',
      hours: 'Години',
      importBoard_title: 'Імпортувати Дошку',
      invalidCurrentPassword: 'Невірний поточний пароль',
      labels: 'Мітки',
      language: 'Мова',
      leaveBoard_title: 'Покинути Дошку',
      leaveProject_title: 'Покинути Проект',
      list: 'Список',
      listActions_title: 'Дії зі Списком',
      managers: 'Менеджери',
      members: 'Учасники',
      minutes: 'Хвилини',
      moveCard_title: 'Перемістити Картку',
      name: 'Назва',
      newEmail: 'Нова електронна пошта',
      newPassword: 'Новий пароль',
      newUsername: "Нове ім'я користувача",
      noConnectionToServer: 'Відсутнє підключення до сервера',
      noBoards: 'Немає дошок',
      noLists: 'Немає списків',
      noProjects: 'Немає проектів',
      notifications: 'Сповіщення',
      noUnreadNotifications: 'Немає непрочитаних сповіщень.',
      openBoard_title: 'Відкрити Дошку',
      optional_inline: 'опціонально',
      organization: 'Організація',
      phone: 'Телефон',
      preferences: 'Уподобання',
      pressPasteShortcutToAddAttachmentFromClipboard:
        'Порада: натисніть Ctrl-V (⌘V на Mac), щоб додати вкладення з буфера обміну.',
      project: 'Проект',
      projectNotFound_title: 'Проект не знайдено',
      removeManager_title: 'Видалити Менеджера',
      removeMember_title: 'Видалити Учасника',
      searchLabels: 'Пошук міток...',
      searchMembers: 'Пошук учасників...',
      searchUsers: 'Пошук користувачів...',
      seconds: 'Секунди',
      selectBoard: 'Вибрати дошку',
      selectList: 'Вибрати список',
      selectPermissions_title: 'Вибрати Дозволи',
      selectProject: 'Вибрати проект',
      settings: 'Налаштування',
      stopwatch: 'Секундомір',
      subscribeToMyOwnCardsByDefault: 'Підписатися на свої картки за замовчуванням',
      taskActions_title: 'Дії з завданням',
      tasks: 'Завдання',
      thereIsNoPreviewAvailableForThisAttachment: 'Для цього вкладення немає доступного перегляду.',
      time: 'Час',
      title: 'Назва',
      userActions_title: 'Дії користувача',
      userAddedThisCardToList: '<0>{{user}}</0><1> додав(ла) цю картку до {{list}}</1>',
      userLeftNewCommentToCard:
        '{{user}} залишив(ла) новий коментар «{{comment}}» до <2>{{card}}</2>',
      userMovedCardFromListToList:
        '{{user}} перемістив(ла) <2>{{card}}</2> з {{fromList}} в {{toList}}',
      userMovedThisCardFromListToList:
        '<0>{{user}}</0><1> перемістив(ла) цю картку з {{fromList}} в {{toList}}</1>',
      username: "Ім'я користувача",
      usernameAlreadyInUse: "Ім'я користувача вже використовується",
      users: 'Користувачі',
      version: 'Версія',
      viewer: 'Переглядач',
      writeComment: 'Написати коментар...',
    },

    action: {
      addAnotherCard: 'Додати іншу картку',
      addAnotherList: 'Додати інший список',
      addAnotherTask: 'Додати інше завдання',
      addCard: 'Додати картку',
      addCard_title: 'Додати Картку',
      addComment: 'Додати коментар',
      addList: 'Додати список',
      addMember: 'Додати учасника',
      addMoreDetailedDescription: 'Додати більш детальний опис',
      addTask: 'Додати завдання',
      addToCard: 'Додати до картки',
      addUser: 'Додати користувача',
      createBoard: 'Створити дошку',
      createFile: 'Створити файл',
      createLabel: 'Створити мітку',
      createNewLabel: 'Створити нову мітку',
      createProject: 'Створити проект',
      delete: 'Видалити',
      deleteAttachment: 'Видалити вкладення',
      deleteAvatar: 'Видалити аватар',
      deleteBoard: 'Видалити дошку',
      deleteCard: 'Видалити картку',
      deleteCard_title: 'Видалити Картку',
      deleteComment: 'Видалити коментар',
      deleteImage: 'Видалити зображення',
      deleteLabel: 'Видалити мітку',
      deleteList: 'Видалити список',
      deleteList_title: 'Видалити Список',
      deleteNotifications: 'Dismiss all',
      deleteProject: 'Видалити проект',
      deleteProject_title: 'Видалити Проект',
      deleteTask: 'Видалити завдання',
      deleteTask_title: 'Видалити Завдання',
      deleteUser: 'Видалити користувача',
      edit: 'Редагувати',
      editDueDate_title: 'Редагувати термін виконання',
      editDescription_title: 'Редагувати опис',
      editEmail_title: 'Редагувати E-mail',
      editInformation_title: 'Редагувати інформацію',
      editPassword_title: 'Редагувати пароль',
      editPermissions: 'Редагувати дозволи',
      editStopwatch_title: 'Редагувати секундомір',
      editTitle_title: 'Редагувати Заголовок',
      editUsername_title: "Редагувати Ім'я користувача",
      hideDetails: 'Сховати деталі',
      import: 'Імпортувати',
      leaveBoard: 'Залишити дошку',
      leaveProject: 'Залишити проект',
      logOut_title: 'Вийти',
      makeCover_title: 'Встановити обкладинку',
      move: 'Перемістити',
      moveCard_title: 'Перемістити Картку',
      remove: 'Видалити',
      removeBackground: 'Видалити фон',
      removeCover_title: 'Видалити обкладинку',
      removeFromBoard: 'Вилучити з дошки',
      removeFromProject: 'Вилучити з проекту',
      removeManager: 'Вилучити керівника',
      removeMember: 'Вилучити учасника',
      save: 'Зберегти',
      showAllAttachments: 'Показати всі вкладення ({{hidden}} приховані)',
      showDetails: 'Показати деталі',
      showFewerAttachments: 'Показати менше вкладень',
      start: 'Почати',
      stop: 'Зупинити',
      subscribe: 'Підписатися',
      unsubscribe: 'Відписатися',
      uploadNewAvatar: 'Завантажити новий аватар',
      uploadNewImage: 'Завантажити нове зображення',
    },
  },
};
